export default __webpack_public_path__ + "95355dd5841590fb982c3a059c80756c.svg";